import {
    sumAllFormatUSD,
    sumCNYFormat,
    sumUSDFormat,
    USDollar,
} from 'utils/format';
import { GlobalContext } from 'GlobalContext';
import { useContext } from 'react';
import { formatCurrency } from 'utils/format';
import { USD_TO_CNY } from 'utils/format';
import { shadeColor } from 'utils/util';

export function InvestorsTableViewSubTable(props) {
    const { account_id, investors, positions, background } = props;
    const { setManageRecordId, setManageRecordTab } = useContext(GlobalContext);

    const center = {
        display: 'flex',
        alignItems: 'center',
        placeContent: 'center',
        textAlign: 'center',
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    // borderBottom: '1px solid black',
                    background,
                }}
            >
                {/* investor holding account id = account_id */}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '150px',
                        ...center,
                    }}
                >
                    {investors.map((investor, iid) => (
                        <div key={iid} style={{}}>
                            <div
                                style={{
                                    color: 'blue',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                }}
                                onClick={(e) => {
                                    setManageRecordId(investor.investor_id);
                                    setManageRecordTab('Investors');
                                }}
                            >
                                {investor.legal_name}
                            </div>

                            <div>{investor.email}</div>
                        </div>
                    ))}
                </div>

                <div
                    style={{
                        width: '150px',
                        color: 'blue',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        ...center,
                    }}
                    onClick={(e) => {
                        setManageRecordId(account_id);
                        setManageRecordTab('Investment Entities');
                    }}
                >
                    {investors[0].account_name}
                </div>

                {/* investment made by account id = account_id */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {positions.map((position, pid) => (
                        <div
                            key={pid}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                // borderTop: pid === 0 ? '' : '1px solid black',
                                flexGrow: 1,
                                ...center,
                                background:
                                    pid % 2 === 0
                                        ? background
                                        : shadeColor(background, 2),
                            }}
                        >
                            <div
                                style={{
                                    width: '150px',
                                    color: 'blue',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    ...center,
                                }}
                                onClick={(e) => {
                                    setManageRecordId(position.fund_id);
                                    setManageRecordTab('Entities/Funds');
                                }}
                            >
                                {position.name}
                            </div>

                            <div style={{ width: '150px', ...center }}>
                                {formatCurrency(
                                    position.amount,
                                    position.currency
                                )}
                            </div>

                            <div style={{ width: '150px', ...center }}>
                                {formatCurrency(
                                    position.account_balance,
                                    position.currency
                                )}
                            </div>

                            <div style={{ width: '150px', ...center }}>
                                {formatCurrency(
                                    position.interest_received,
                                    position.currency
                                )}
                            </div>

                            <div style={{ width: '150px', ...center }}>
                                {formatCurrency(
                                    position.principal_returned,
                                    position.currency
                                )}
                            </div>

                            <div style={{ width: '150px', ...center }}>
                                {position.overall_interest
                                    ? Math.max(
                                          position.overall_interest,
                                          position.annual_interest_rate
                                      )
                                    : position.annual_interest_rate}
                                %
                            </div>

                            <div style={{ width: '150px', ...center }}>
                                {position.funding_receipt_date.slice(0, 10)}
                            </div>

                            <div style={{ width: '150px', ...center }}>
                                {position.actual_redemption_date.slice(0, 10)}
                            </div>

                            <div
                                style={{
                                    width: '50px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                <button
                                    style={{
                                        background: 'rgb(17 32 86)',
                                        color: 'white',
                                        height: '30px',
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                        setManageRecordId(
                                            position.investment_id
                                        );
                                        setManageRecordTab('Positions');
                                    }}
                                >
                                    Detail
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    // borderBottom: '1px solid black',
                    fontWeight: 'bold',
                    background: shadeColor(background, -1.5),
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ width: '150px', ...center }}>Sum USD</div>
                    <div style={{ width: '150px', ...center }}>Sum CNY</div>
                </div>
                <div style={{ width: '300px', alignContent: 'center' }}></div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ width: '150px', ...center }}>
                        {sumUSDFormat(positions, 'amount')}
                    </div>
                    <div style={{ width: '150px', ...center }}>
                        {sumCNYFormat(positions, 'amount')}
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ width: '150px', ...center }}>
                        {sumUSDFormat(positions, 'account_balance')}
                    </div>
                    <div style={{ width: '150px', ...center }}>
                        {sumCNYFormat(positions, 'account_balance')}
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ width: '150px', ...center }}>
                        {sumUSDFormat(positions, 'interest_received')}
                    </div>
                    <div style={{ width: '150px', ...center }}>
                        {sumCNYFormat(positions, 'interest_received')}
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ width: '150px', ...center }}>
                        {sumUSDFormat(positions, 'principal_returned')}
                    </div>
                    <div style={{ width: '150px', ...center }}>
                        {sumCNYFormat(positions, 'principal_returned')}
                    </div>
                </div>
            </div>
        </>
    );
}
